/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/oil_medium'
export default icon
